import styled, { css } from 'styled-components'

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 20px;
    color: var(--colorFontsCardsDashboard);
`

export const BarData = styled.div`

    width: 100%;
    display: flex;
    align-items: center;
    font-weight: 900;
    position: relative;
    z-index: ${({ isExportButtonVisible }) => isExportButtonVisible ? '-9' : '0'};

    .info {
        width: 30%;
        margin-right: 0.1rem;
        font-size: 0.8rem;

        strong {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            display: block;
        }

        span {
            color: gray;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            display: block;
        }
    }

    svg {
        color: gray;
        cursor: pointer;
    }

    p{
        font-size: 0.9rem;
    }

    .perc{
        width: 10%;
    }
`

export const BarContainer = styled.div`
    flex: auto;
    height: 100%;
    margin-right: 0.2rem;
    margin-bottom: 5px;

    display: flex;
    align-items: center;

    border: 0.2px solid #E6E6E6;
`

export const Bar = styled.div`
    height: 2rem;
    background: #2e9699;
  
    color: #FFF;
    
    display: flex;
    align-items: center;
    justify-content: center;

    ${props => props.percent && css`
        width: ${props.percent + '%'};
    `};
`